var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrabHandlelarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.67,
    cy: 4.67,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.67,
    cy: 4.67,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.67,
    cy: 12.67,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.67,
    cy: 12.67,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.67,
    cy: 20.67,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.67,
    cy: 20.67,
    r: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrabHandlelarge);
export default __webpack_public_path__ + "static/media/grabHandle.large.e3428afea8aaf46a234437fc9ceaa894.svg";
export { ForwardRef as ReactComponent };